import { SUCCESS } from '../../../../../constants/action-postfix'
import { EDU_COMMISSIONS_GET_REQUEST } from '../../eduCommissionsActionTypes'

const initialState = null

export const eduCommissionsCurrentDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${EDU_COMMISSIONS_GET_REQUEST}${SUCCESS}`:
      return action.payload

    default:
      return state
  }
}
